<template>
    <svg
        id="Capa_1"
        style="enable-background: new 0 0 228 228"
        version="1.1"
        viewBox="0 0 228 228"
        x="0px"
        xml:space="preserve"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        y="0px"
    >
        <g>
            <path
                d="M0,178.946c0,9.71,9.227,18.554,18.991,18.554h192.152c9.479,0,16.856-8.323,16.856-18.554V163.5H0V178.946z"
            ></path>
            <path
                d="M211.144,30.5H18.991C8.877,30.5,0,38.539,0,48.054V139.5h228V48.054C228,38.211,220.782,30.5,211.144,30.5z    M182.276,115.753c-8.508,0-16.213-3.435-21.808-8.991c-5.595,5.556-13.3,8.991-21.809,8.991   c-17.096,0-30.954-13.859-30.954-30.954c0-17.095,13.859-30.954,30.954-30.954c8.508,0,16.213,3.435,21.809,8.991   c5.595-5.556,13.3-8.991,21.808-8.991c17.095,0,30.954,13.859,30.954,30.954C213.23,101.894,199.371,115.753,182.276,115.753z"
            ></path>
        </g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
    </svg>
</template>

<script>
export default {
    name: "CreditCard",
};
</script>
